import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axiosInstance from "../../../hooks/axiosInstance";
import { toast } from "react-toastify";
import { Pagination } from "@mui/material";
import Loader from "../../utilities/Loader/Loader";

const DuesApplication = ({ isActive }) => {
  const [loading, setLoading] = useState();
  const [dues, setDues] = useState([]);
  const [currentDue, setCurrentDue] = useState(null);
  const [membersDue, setMembersDue] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showSubmit, setShowSubmit] = useState(false);
  
  const [filter, setFilter] = useState({
    dueId: "",
    search: "",
    paginated: true,
  });

  //  state for pagination
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [pageCount, setPageCount] = useState(1);

  //  pagination function
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;

    setFilter((prevFilter) => ({ ...prevFilter, [name]: value }));

    const filteredDue = dues.filter((due) => due.id == value);
    setCurrentDue(filteredDue[0]);
  };

  const handleSelectAll = (event) => {
    setSelectAll(event.target.checked);
    setSelectedRows(event.target.checked ? membersDue.map((member) => member.id) : []);
    setShowSubmit(event.target.checked);
  };

  const handleRowSelect = (event, id) => {
    const isChecked = event.target.checked;
    let newSelectedRows = [...selectedRows];

    if (isChecked) {
      newSelectedRows.push(id);
    } else {
      newSelectedRows = newSelectedRows.filter((rowId) => rowId !== id);
    }

    setSelectedRows(newSelectedRows);
    setSelectAll(newSelectedRows.length === membersDue.length); // Update selectAll
    setShowSubmit(newSelectedRows.length > 0);
  };

  const fetchAssociationDues = async () => {
    setLoading(true);
    axiosInstance
      .post(`/association/dues/fetch`)
      .then((response) => {
        setDues(response.data.data);
        setCurrentDue(response.data.data[0]);
        setFilter({ ...filter, dueId: response.data.data[0].id });
      })
      .catch((err) => {
        toast.error("An error occured. Please, try again");
      })
      .finally(() => setLoading(false));
  };

  const fetchMembersDue = () => {
    setLoading(true);
    axiosInstance
      .post(`/association/dues/members/fetch?page=${page}`, filter)
      .then((response) => {
        setMembersDue(response.data.data.data);
        markAttachedDues(response.data.data.data)
        const pageCount = Math.ceil(
          response.data.data.total / response.data.data.per_page
        );
        setPageCount(pageCount);
      })
      .catch((err) => {
        toast.error("An error occured. Please, try again");
      })
      .finally(() => setLoading(false));
  };

  const markAttachedDues = (members) => {
    const selectedMember = members.map((member) => {
        if (member.dues && member.dues.length > 0) {
            return member.id;
        }
        return null;
    }).filter(id => id !== null)
    setSelectedRows(selectedMember)
    setSelectAll(selectedMember.length === members.length); // Update selectAll
  }

  const handleSubmit = () => {
    setLoading(true);
    axiosInstance
      .post(`/association/dues/members/attach`, {dueId: currentDue.id, data: selectedRows})
      .then((response) => {
        toast.success(response.data.message)
        fetchMembersDue()
      })
      .catch((err) => {
        toast.error("An error occured. Please, try again");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (isActive) {
      fetchAssociationDues();
    }
  }, [isActive]);

  useEffect(() => {
    if (isActive) {
      fetchMembersDue();
    }
  }, [isActive, filter]);

  return (
    <>
      <div className="card" id="invoiceList">
        <div className="card-header border-0">
          <div className="d-flex align-items-center">
            <h5 className="card-title mb-0 flex-grow-1">
              Attach{" "}
              <b className="text-success font-weight-bolder">
                {currentDue?.name}
              </b>{" "}
              to members
            </h5>
            {showSubmit && <div className="flex-shrink-0">
                <div className="d-flex gap-2 flex-wrap">
                    {/* <button className="btn btn-primary" id="remove-actions" onClick="deleteMultiple()"><i className="ri-delete-bin-2-line"></i>1s</button> */}
                    <button onClick={handleSubmit} className="btn btn-info"><i className="ri-add-line align-bottom me-1"></i> Attach Due</button>
                </div>
            </div>}
          </div>
        </div>
        <div className="card-body bg-light-subtle border border-dashed border-start-0 border-end-0">
          <form>
            <div className="row g-3">
              <div className="col-xxl-3 col-sm-4">
                <div className="input-light">
                  <select
                    className="form-control"
                    name="dueId"
                    value={filter.dueId}
                    onChange={handleFilterChange}
                  >
                    {dues.map((due) => (
                      <option
                        value={due.id}
                        key={due.id}
                        selected={due.id == currentDue.id}
                      >
                        {due.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              {/* <!--end col--> */}
              <div className="col-xxl-5 col-sm-12">
                <div className="search-box">
                  <input
                    type="text"
                    className="form-control search bg-light border-light"
                    placeholder="Search for members..."
                    name="search"
                    value={filter.search}
                    onChange={handleFilterChange}
                  />
                  <i className="ri-search-line search-icon"></i>
                </div>
              </div>
              {/* <!--end col--> */}
              <div className="col-xxl-1 col-sm-4">
                <button
                  type="button"
                  className="btn btn-primary w-100"
                  onClick={fetchMembersDue}
                >
                  <i className="ri-equalizer-fill me-1 align-bottom"></i>{" "}
                  Filters
                </button>
              </div>
              {/* <!--end col--> */}
            </div>
            {/* <!--end row--> */}
          </form>
        </div>
        <div className="card-body">
          <div>
            <div className="table-responsive table-card">
              {membersDue.length > 0 && (
                <>
                  <table
                    className="table align-middle table-nowrap"
                    id="invoiceTable"
                  >
                    <thead className="text-muted">
                      <tr>
                        <th scope="col" style={{ width: "50px" }}>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={selectAll} 
                              onChange={handleSelectAll}
                            />
                          </div>
                        </th>
                        <th
                          className="sort text-uppercase"
                          data-sort="invoice_id"
                        >
                          Membership ID
                        </th>
                        <th
                          className="sort text-uppercase"
                          data-sort="customer_name"
                        >
                          Member Info
                        </th>
                        <th className="sort text-uppercase" data-sort="email">
                          Email
                        </th>
                        <th className="sort text-uppercase" data-sort="country">
                          Phone
                        </th>
                        <th className="sort text-uppercase" data-sort="status">
                          Payment Status
                        </th>
                        <th className="sort text-uppercase" data-sort="date">
                          Date Paid
                        </th>
                        <th className="sort text-uppercase" data-sort="action">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      className="list form-check-all"
                      id="invoice-list-data"
                    >
                      {membersDue.map((member) => (
                        <tr key={member.id}>
                          <th scope="row">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={selectedRows.includes(member.id)}
                                onChange={(event) => handleRowSelect(event, member.id)}
                              />
                            </div>
                          </th>
                          <td className="id">
                            <a
                              href="javascript:void(0);"
                              className="fw-medium link-primary"
                            >
                              {member.membership_id
                                ? member.membership_id
                                : "-"}
                            </a>
                          </td>
                          <td className="customer_name">
                            <div className="d-flex align-items-center">
                              <img
                                src="/assets/images/users/avatar-1.jpg"
                                alt=""
                                className="avatar-xs rounded-circle me-2"
                              />
                              {member?.user?.last_name ? (
                                <span>
                                  {member?.user?.last_name}{" "}
                                  {member?.user?.first_name}{" "}
                                  {member?.user?.middle_name}
                                </span>
                              ) : (
                                <span>---------</span>
                              )}
                            </div>
                          </td>
                          <td className="email">{member?.user?.email}</td>
                          <td className="country">{member?.user?.phone}</td>
                          <td className="status">
                            {(member.dues.length == 0 ||
                              (member.dues.length > 0 &&
                                member.dues[0].status == "pending")) && (
                              <span className="badge bg-warning-subtle text-warning text-uppercase">
                                Pending
                              </span>
                            )}
                            {member.dues.length > 0 &&
                              member.dues[0].status == "paid" && (
                                <span className="badge bg-success-subtle text-success text-uppercase">
                                  Paid
                                </span>
                              )}
                          </td>
                          <td className="date">
                            {member.dues.length > 0 &&
                            member.dues[0].status == "paid" ? (
                              <span>{member.dues[0].date_paid}</span>
                            ) : (
                              <span>-</span>
                            )}
                          </td>
                          <td>
                            <Link
                              to={`attach/${member.id}`}
                              className="btn btn-sm btn-soft-secondary"
                            >
                              Manage
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="row g-0 text-center text-sm-start align-items-center mb-4">
                    {/* <div className="col-sm-6">
                                        <div>
                                            <p className="mb-sm-0 text-muted">Showing <span className="fw-semibold">1</span> to <span className="fw-semibold">10</span> of <span className="fw-semibold text-decoration-underline">12</span> entries</p>
                                        </div>
                                    </div> */}
                    {/* <!-- end col --> */}
                    <div className="col-sm-12 d-flex justify-content-end mt-4">
                      <Pagination
                        onChange={handlePageChange}
                        count={pageCount}
                        color="primary"
                        shape="rounded"
                        size="small"
                        page={page}
                      />
                    </div>
                    {/* <!-- end col --> */}
                  </div>
                </>
              )}
              {membersDue.length == 0 && (
                <div className="noresult">
                  <div className="text-center">
                    <lord-icon
                      src="https://cdn.lordicon.com/msoeawqm.json"
                      trigger="loop"
                      colors="primary:#405189,secondary:#0ab39c"
                      style={{ width: "75px", height: "75px" }}
                    ></lord-icon>
                    <h5 className="mt-2">Sorry! No Result Found</h5>
                    {/* <p className="text-muted mb-0">We've searched more than 150+ orders We did not find any orders for you search.</p> */}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {loading && <Loader />}
    </>
  );
};

export default DuesApplication;
